import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useCancelBooking, useSubmitBooking } from "../../services/mutations";
import { useGetCurrency } from "../../services/queries";

const BookingCard = ({ filterData, roomByFilter }) => {
  const location = useLocation();
  // Parse query parameters
  const queryParams = new URLSearchParams(location.search);
  const startDate = queryParams.get("start");
  const endDate = queryParams.get("end");
  const [Data, setData] = useState({
    id: roomByFilter?.roomId,
    adult: roomByFilter?.adult,
    child: roomByFilter?.child,
    startDate: queryParams.get("start"),
    endDate: queryParams.get("end"),
    currency:1
  });
  const [confirmationData, setConfirmationData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [submitButton, setSubmitButton] = useState(false);
  const [cancelButton, setCancelButton] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
   const { mutate:cancelBooking } = useCancelBooking();
   const { mutate:submitBooking } = useSubmitBooking();
   const { data:egpCurrency } = useGetCurrency();
   const navigate = useNavigate();
   const [currency, setCurrency] = useState(1);
 

  const handleSubmit = async (e) => { 
    if (!localStorage.getItem("token")) {
      navigate("/login")
    }
    setSubmitButton(true)
    console.log(currency);
    
    Data.id=roomByFilter?.id;
    Data.child=roomByFilter?.child;
    Data.adult=roomByFilter?.adult;
    Data.currency=parseInt(currency);
    e.preventDefault();
    console.log(Data);
    
submitBooking(Data, {
  onSuccess: (res) => { 
    console.log(res);
    setConfirmationData(res);
    setShowModal(true); 
    setSubmitButton(false)
  },
  onError: (err) => {
    setSubmitButton(false)
    console.log(err);

  },
});
   
  };
  const handleRemoveBook = async () => {
   setCancelButton(true)
    console.log(confirmationData?.reference_number);
    cancelBooking(confirmationData?.reference_number, {
      onSuccess: (res) => {      
        closeModal()
        console.log(res);
      },
      onError: (err) => {
        console.error("Error confirming payment:", err);
        closeModal()
      },
    });
      
  };
  const handleConfirm = () => {
    if (!termsAccepted) {
      alert("Please accept the terms and conditions before proceeding");
      return;
    }
    const form = document.createElement("form");
    form.method = "POST";
    form.action = "https://secureacceptance.cybersource.com/pay";

    for (const key in confirmationData) {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = confirmationData[key];
      form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
  };

  const closeModal = () => {
    setShowModal(false); 
    setCancelButton(false);
  };
 
  return (
    <div className="card p-3 shadow-sm bg-white w-75">
      {/* Price Section */}
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div>
          <span className="fw-bold fs-4">${roomByFilter?.perNight}</span>
          <span className="text-muted"> /night</span>
        </div>
        <div>
          <span className="text-warning fw-bold">★ 4.8</span>
          <span className="text-muted ms-1">(256 reviews)</span>
        </div>
      </div>

      {/* Date and Guests */}
      <div className="d-flex justify-content-between bg-light p-2 rounded mb-3">
        <div>
          <div className="fw-bold">Date</div>
          <div className="text-muted">{startDate}</div>
        </div>
        <div>
          <div className="fw-bold">Guests</div>
          <div className="text-muted">{roomByFilter?.adult} adult</div>
          {roomByFilter?.child ? (
            <div className="text-muted">and {roomByFilter?.child} guests</div>
          ) : (
            ""
          )}
        </div>
      </div>
      <Link
        to={`/book-room/${roomByFilter?.hotelId}`}
        className="text-primary-me text-center fw-bold mb-3"
      >
        See More Rooms
      </Link>

      {/* Check-in and Check-out */}
      <div className="mb-3">
        <label className="fw-bold mb-1">CHECK IN</label>
        <input
          type="date"
          className="form-control"
          defaultValue={startDate}
          disabled
        />
      </div>
      <div className="mb-3">
        <label className="fw-bold mb-1">CHECK OUT</label>
        <input
          type="date"
          className="form-control"
          defaultValue={endDate}
          disabled
        />
      </div>

      {/* Total Nights */}
      <div className="mb-4">
        <label className="fw-bold mb-1 d-block">TOTAL NIGHT</label>
        <p>{roomByFilter?.nights}</p>
      </div>

      {/* Total Price */}
        <div className="text-muted fw-bold">Total for {roomByFilter?.adult} people</div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="fs-3 fw-bold">{currency==1? '$ '+roomByFilter?.total:(egpCurrency*roomByFilter?.total)+' LE'}</div>
        <div className="mb-3">
  <label className="form-label ">Select Currency</label>
  <select
    className="form-select"
    value={currency}
    onChange={(e) => setCurrency(e.target.value)}>
    <option value="1">USD</option>
    <option value="0">EGP</option>
  </select>
</div>
      </div>

      {/* Book Now Button */}

      {roomByFilter?.available ? (
        <div className="py-2 text-end">
          <button onClick={(e)=>handleSubmit(e)} disabled={submitButton} className="btn bgPrimaryColor text-white rounded-5 btn-lg custom-btn block">
           {submitButton?"Preparing...":"Book Now"}
          </button>
        </div>
      ) : (
        <Link
          to={`/bookRoom/${roomByFilter?.hotelId}`}
          className="text-primary-me fw-bold mb-3"
        >
          Sorry,this room is not available in this time See More Rooms
        </Link>
      )}
   
       {showModal && (
        <div className={`modal fade show`} style={{ display: "block" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Payment</h5>
                <button type="button" className="btn-close" onClick={() => handleRemoveBook()}></button>
              </div>
              <div className="modal-body">
                <div className="confirmation-details">
                  <div className="mb-2">
                    <strong>Name:</strong> <span>{confirmationData?.bill_to_forename } {confirmationData?.bill_to_surname}</span>
                  </div>
                  <div className="mb-2">
                    <strong>Email:</strong> <span>{confirmationData?.bill_to_email || "N/A"}</span>
                  </div>
                  <div className="mb-2">
                    <strong>Total:</strong> <span>{confirmationData?.amount || "N/A"}</span>
                  </div>
                  <div className="mb-2">
                    <strong>Currency:</strong> <span>{confirmationData?.currency || "N/A"}</span>
                  </div>
                </div>
                <div className="mt-3">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="termsCheckbox"
                      checked={termsAccepted}
                      onChange={(e) => setTermsAccepted(e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="termsCheckbox">
                      I agree to the <Link to="/terms" target="_blank" className="text-primary">Terms and Conditions</Link>
                    </label>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" disabled={cancelButton} onClick={(e) =>handleRemoveBook(e) }>
                  Cancel
                </button>
                <button 
                  type="button" 
                  className="btn btn-primary" 
                  disabled={cancelButton || !termsAccepted} 
                  onClick={handleConfirm}
                >
                  Confirm Payment
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
   
    </div>
  );
};

export default BookingCard;
